/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { useConsoleServiceStore, useIdentityGatewayServiceStore } from 'dxpConsoleCore-mf/State';
import { lastValueFrom } from 'rxjs';
import { LOCAL_STORAGE_KEY_DXP_SERVICE_TOKENS, getConsoleService } from '../../Services/console';

/**
 * Get the user's DXP Service Tokens.
 */
export const getServiceTokens = async (): Promise<void> => {
  const consoleService = getConsoleService();
  const { updateTokens } = useConsoleServiceStore.getState();
  const { updateSessionIssue } = useIdentityGatewayServiceStore.getState();

  await lastValueFrom(consoleService.getDxpServiceTokens())
    .then((consoleResponse) => {
      const { tokens } = consoleResponse;
      localStorage.setItem(LOCAL_STORAGE_KEY_DXP_SERVICE_TOKENS, JSON.stringify(tokens));
      updateTokens(tokens);

      return true;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      updateSessionIssue(true);
    });
};
